import React from "react";

function Header() {
  return (
    <div>
      <header className="site-header">
        <div className="header-menu">
          <a href="#">
            <div className="brand-name">
              <p className="bold">UX/UI Design</p>
              <svg
                width="43"
                height="43"
                viewBox="0 0 43 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="brand-icon"
              >
                <circle
                  cx="21.5"
                  cy="21.5"
                  r="15.5"
                  stroke="#FFCC00"
                  stroke-width="12"
                />
              </svg>
            </div>
          </a>

          <a href="#">
            <p>Usability Testing</p>
          </a>

          <a href="#">
            <p>Blog</p>
          </a>
        </div>

        {/* Logo */}
        <svg
          width="74"
          height="70"
          viewBox="0 0 74 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="header-logo"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M47.8485 1.04644L47.8654 1.0871L52.0279 12.9205C60.8939 18.1703 66.8437 27.8682 66.8437 38.9623C66.8437 39.1265 66.8424 39.2904 66.8398 39.4539L72.9542 41.0524C73.086 41.0869 73.1889 41.1903 73.2231 41.3227C73.2716 41.5101 73.1713 41.7012 72.996 41.7696L72.9542 41.7831L66.5118 43.4682C66.3732 44.4005 66.1922 45.3188 65.9709 46.2211L72.176 49.9076C72.2931 49.9773 72.3637 50.1052 72.3603 50.242C72.3555 50.4356 72.2066 50.5915 72.0194 50.6086L71.9756 50.61L64.6052 50.426C64.2784 51.2265 63.9184 52.0098 63.527 52.7742L68.1659 57.5341C68.2612 57.6319 68.2963 57.7738 68.2578 57.9051C68.2034 58.0908 68.0194 58.2026 67.8342 58.1704L67.7915 58.1604L61.425 56.2732C55.9946 64.0684 46.996 69.1647 36.8139 69.1647C26.6706 69.1647 17.7019 64.1084 12.2643 56.3651L6.20857 58.1604C6.00966 58.2194 5.80086 58.1051 5.74221 57.9051C5.7037 57.7738 5.73889 57.6319 5.83417 57.5341L10.2281 53.0254C9.78754 52.1847 9.38522 51.3206 9.0235 50.4354L2.02447 50.61C1.81715 50.6152 1.6449 50.4505 1.63974 50.242C1.63635 50.1052 1.70689 49.9773 1.82409 49.9076L7.70222 46.4155C7.45045 45.4178 7.24805 44.4003 7.0978 43.3658L1.0458 41.7831C0.845099 41.7306 0.724711 41.5245 0.776909 41.3227C0.811172 41.1903 0.914057 41.0869 1.0458 41.0524L6.78652 39.5514C6.7828 39.3555 6.78092 39.1592 6.78092 38.9623C6.78092 27.673 12.9424 17.8296 22.0687 12.6476L26.1346 1.0871C26.1724 0.979596 26.2565 0.895032 26.3635 0.857022C26.545 0.792486 26.743 0.876696 26.8257 1.04644L26.8426 1.0871L29.831 9.58378C32.0717 9.04722 34.4098 8.76316 36.8139 8.76316C39.3408 8.76316 41.7948 9.07707 44.1395 9.66821L47.1574 1.0871C47.1952 0.979596 47.2793 0.895032 47.3862 0.857022C47.5678 0.792486 47.7658 0.876696 47.8485 1.04644ZM36.8145 21.2209C27.0665 21.2209 19.1641 29.1655 19.1641 38.9639C19.1641 48.7653 27.0665 56.707 36.8145 56.707C46.561 56.707 54.4606 48.7653 54.4606 38.9639C54.4606 29.1655 46.561 21.2209 36.8145 21.2209ZM36.8122 28.7712C37.2017 28.7712 37.5368 29.0483 37.6119 29.4325L39.3788 38.4654C39.4547 38.8535 39.454 39.2529 39.3768 39.6408L37.6141 48.496C37.5376 48.8803 37.202 49.1569 36.8122 49.1569C36.4225 49.1569 36.087 48.8801 36.0109 48.4958L34.247 39.5886C34.1702 39.2007 34.1699 38.8013 34.2462 38.4133L36.0118 29.4324C36.0874 29.0482 36.4226 28.7712 36.8122 28.7712Z"
            fill="#5B24B3"
          />
        </svg>
        <div className="header-menu">
          <a href="#">
            <p>About us</p>
          </a>

          <a href="#">
            <p>Contacts</p>
          </a>

          <a href="mailto:ilove@opium.pro">
            <p className="bold underline">ilove@opium.pro</p>
          </a>
        </div>
        <div id="menuToggle">
          <input type="checkbox" />
          <span></span>
          <span></span>
          <span></span>
          <div id="menu">
            <div className="mobile-items">
              <a href="#">
                <div className="brand-name">
                  <p className="bold">UX/UI Design</p>
                  <svg
                    width="43"
                    height="43"
                    viewBox="0 0 43 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="brand-icon"
                  >
                    <circle
                      cx="21.5"
                      cy="21.5"
                      r="15.5"
                      stroke="#FFCC00"
                      stroke-width="12"
                    />
                  </svg>
                </div>
              </a>

              <a href="#">
                <p>Usability Testing</p>
              </a>

              <a href="#">
                <p>Blog</p>
              </a>

              <a href="#">
                <p>About us</p>
              </a>

              <a href="#">
                <p>Contacts</p>
              </a>

              <a href="mailto:ilove@opium.pro">
                <p className="bold underline">ilove@opium.pro</p>
              </a>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
